import {
  Article,
  Church,
  Home,
  Collections,
  Settings,
  Group,
  Person,
  MenuBook,
  Cake,
} from "@mui/icons-material";

export const menuItems = [
  { title: "Dashboard", icon: <Home />, path: "/home" },
  { title: "Events", icon: <Church />, path: "/event" },
  { title: "Articles", icon: <Article />, path: "/article" },
  { title: "Gallery", icon: <Collections />, path: "/gallery" },
  { title: "Authors", icon: <Person />, path: "/author" },
  { title: "Members", icon: <Group />, path: "/members" },
  { title: "Birthdays", icon: <Cake />, path: "/birthdays" },
  { title: "SBC Tracts", icon: <MenuBook />, path: "/sbc-tracts" },
  { title: "Settings", icon: <Settings />, path: "/settings" },
];
